import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3311260563 from "../../../../../packages/component/src/components/cascader-select/demo/demo1.js?loadDemo";
import legacyImportDemo_2500265104 from "../../../../../packages/component/src/components/cascader-select/demo/demo2.js?loadDemo";
import legacyImportDemo_2647139985 from "../../../../../packages/component/src/components/cascader-select/demo/demo3.js?loadDemo";
import legacyImportDemo_227648150 from "../../../../../packages/component/src/components/cascader-select/demo/demo4.js?loadDemo";
import legacyImportDemo_2107339159 from "../../../../../packages/component/src/components/cascader-select/demo/demo5.js?loadDemo";
import legacyImportDemo_9893524 from "../../../../../packages/component/src/components/cascader-select/demo/demo6.js?loadDemo";
import legacyImportDemo_861029525 from "../../../../../packages/component/src/components/cascader-select/demo/demo7.js?loadDemo";
import legacyImportDemo_3621109402 from "../../../../../packages/component/src/components/cascader-select/demo/demo8.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3311260563,
  legacyImportDemo_2500265104,
  legacyImportDemo_2647139985,
  legacyImportDemo_227648150,
  legacyImportDemo_2107339159,
  legacyImportDemo_9893524,
  legacyImportDemo_861029525,
  legacyImportDemo_3621109402,
  React
};